import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class AbnormalGoodsOrderAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getAbnormalGoodsOrderRecordTableList', {
            url: '/admin/ktv/goods/exception/index',
            name: 'list',
            label: '列表'
        }],
        ['exportExcelAbnormalGoodsOrderTableList', {
            url: '/admin/ktv/goods/exception/export',
            name: 'export-excel',
            label: '导出'
        }],
        // ['searchVenueList', {
        //     url: '/admin/coupons/shop/list',
        //     name: 'shop-list',
        //     label: '店铺列表',
        // }],
    ])

    // 商品异常订单列表
    public getAbnormalGoodsOrderRecordTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getAbnormalGoodsOrderRecordTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // // 导出商品异常订单列表
    public exportExcelAbnormalGoodsOrderTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('exportExcelAbnormalGoodsOrderTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 搜索店铺列表
    // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('searchVenueList').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }
}